<template>
  <div class="thai-hilo-bet">
    <div class="thai-hilo-lo">
      <new-bet-lot
        class="thai-hilo-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :type="odd6Lo"
        :win="odd6Lo"
        :odd="odd(odd6Lo)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(odd6Lo)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </div>
    <div class="thai-hilo-eleven-lo">
      <new-bet-lot
        class="thai-hilo-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :type="odd11HL"
        :win="odd11HL"
        :odd="odd(odd11HL)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(odd11HL)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </div>
    <div class="thai-hilo-lo">
      <new-bet-lot
        class="thai-hilo-betlot"
        gameType="thai_hilo"
        game="thai-hilo"
        :type="odd5Lo"
        :win="odd5Lo"
        :odd="odd(odd5Lo)"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(odd5Lo)"
        @update-session-storage="onUpdateSessionStorage"
        size="small"
      />
    </div>
  </div>
</template>

<script>
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["winCellNo", "game", "gameData"],
  components: {
    NewBetLot
  },
  data() {
    return {
      odd6Lo: "o4",
      odd11HL: "o3",
      odd5Lo: "o5"
    };
  }
};
</script>
<style scoped>
.thai-hilo-bet {
  width: 100%;
  height: 60px;
  position: relative;
}
.thai-hilo-lo {
  width: 30%;
  height: 60px;
  border: 1px solid white;
  display: inline-block;
}

.thai-hilo-eleven-lo {
  width: 40%;
  height: 60px;
  border: 1px solid white;
  display: inline-block;
}
</style>